export const PIPELINE_ACTION_ACTIVATE = 'activate';
export const PIPELINE_ACTION_PAUSE = 'pause';
export const PIPELINE_ACTION_DELETE = 'delete';
export const PIPELINE_ACTION_MOVE_TO_PROJECT = 'move_to_project';
export const PIPELINE_ACTION_RESTORE = 'restore';

// Archival status values
export const ARCHIVAL_STATUS_LIVE = 'LIVE';
export const ARCHIVAL_STATUS_ARCHIVED = 'ARCHIVED';
export const ARCHIVAL_STATUS_RESTORING = 'RESTORING';

export const PIPELINE_CARD_WIDTH = 280;
export const PIPELINE_CARD_SPACING = 60;

export const FLOW_TYPE_AUTO = 'auto';
export const FLOW_TYPE_STREAMING = 'streaming';
export const FLOW_TYPE_REPLICATION = 'replication';
export const FLOW_TYPE_IN_MEMORY = 'in_memory';
export const FLOW_TYPE_CUSTOM = 'custom';
export const FLOW_TYPE_SPARK = 'spark';
export const FLOW_TYPE_CDC = 'cdc';
export const FLOW_TYPE_ELT = 'elt';
export const FLOW_TYPE_RAG = 'rag';
export const FLOW_TYPE_API_SERVER = 'api_server';

// Flow types that don't support live samples - users will only see cached sample options
// Live samples require real-time data streaming (e.g., from Kafka), which these flow types don't provide
export const FLOW_TYPES_WITHOUT_LIVE_SAMPLES = [
  FLOW_TYPE_IN_MEMORY, // Direct Flow - processed in memory
  FLOW_TYPE_CUSTOM, // BYO Flow - custom processing
  FLOW_TYPE_REPLICATION, // Replication Flow - batch replication
  FLOW_TYPE_SPARK, // Spark ETL Flow - batch processing
  FLOW_TYPE_RAG, // RAG Flow - query-based retrieval
  FLOW_TYPE_API_SERVER, // API Server Flow - API endpoints
];

export const DELETE_DISABLED_MESSAGES = {
  FLOW: 'Flows must be paused before deleting',
  NEXSET: 'Nexsets must be paused before deleting',
  SOURCE: 'Sources must be paused before deleting',
  DESTINATION: 'Destinations must be paused before deleting',
};
